import {
    FETCH_QUESTIONS_REQUEST,
    FETCH_QUESTIONS_SUCCESS,
    FETCH_QUESTIONS_FAILURE,

    CREATE_QUESTION_REQUEST,
    CREATE_QUESTION_SUCCESS,
    CREATE_QUESTION_FAILURE,

    UPDATE_QUESTION_REQUEST,
    UPDATE_QUESTION_SUCCESS,
    UPDATE_QUESTION_FAILURE,

    DELETE_QUESTION_REQUEST,
    DELETE_QUESTION_SUCCESS,
    DELETE_QUESTION_FAILURE,
} from "./types";


import {
    fetchQuestions,
    createQuestion,
    updateQuestion,
    deleteQuestion,
} from "../../services/questionService";


export const fetchQuestionsRequest = () => ({
    type: FETCH_QUESTIONS_REQUEST,
});


export const fetchQuestionsSuccess = (
    questions
) => ({
    type: FETCH_QUESTIONS_SUCCESS,
    payload: questions,
});


export const fetchQuestionsFailure = (
    error
) => ({
    type: FETCH_QUESTIONS_FAILURE,
    payload: error,
});



export const createQuestionRequest = () => ({
    type: CREATE_QUESTION_REQUEST,
});


export const createQuestionSuccess = (
    question
) => ({
    type: CREATE_QUESTION_SUCCESS,
    payload: question,
});


export const createQuestionFailure = (
    error
) => ({
    type: CREATE_QUESTION_FAILURE,
    payload: error,
});



export const updateQuestionRequest = () => ({
    type: UPDATE_QUESTION_REQUEST,
});


export const updateQuestionSuccess = (
    question
) => ({
    type: UPDATE_QUESTION_SUCCESS,
    payload: question,
});


export const updateQuestionFailure = (
    error
) => ({
    type: UPDATE_QUESTION_FAILURE,
    payload: error,
});



export const deleteQuestionRequest = () => ({
    type: DELETE_QUESTION_REQUEST,
});


export const deleteQuestionSuccess = (
    questionId
) => ({
    type: DELETE_QUESTION_SUCCESS,
    payload: questionId,
});


export const deleteQuestionFailure = (
    error
) => ({
    type: DELETE_QUESTION_FAILURE,
    payload: error,
});

export const fetchQuestionsAction =
    (assessmentId) => async (dispatch) => {

        dispatch(
            fetchQuestionsRequest()
        );

        try {

            const response =
                await fetchQuestions(
                    assessmentId
                );

            if (response.success) {

                dispatch(
                    fetchQuestionsSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                fetchQuestionsFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to fetch questions";

            dispatch(
                fetchQuestionsFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const createQuestionAction =
    (payload) => async (dispatch) => {

        dispatch(
            createQuestionRequest()
        );

        try {

            const response =
                await createQuestion(
                    payload
                );

            if (response.success) {

                dispatch(
                    createQuestionSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                createQuestionFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to create question";

            dispatch(
                createQuestionFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };


export const updateQuestionAction =
    (
        questionId,
        payload
    ) => async (dispatch) => {

        dispatch(
            updateQuestionRequest()
        );

        try {

            const response =
                await updateQuestion(
                    questionId,
                    payload
                );

            if (response.success) {

                dispatch(
                    updateQuestionSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                };

            }

            dispatch(
                updateQuestionFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to update question";

            dispatch(
                updateQuestionFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };



export const deleteQuestionAction =
    (questionId) => async (dispatch) => {

        dispatch(
            deleteQuestionRequest()
        );

        try {

            const response =
                await deleteQuestion(
                    questionId
                );

            if (response.success) {

                dispatch(
                    deleteQuestionSuccess(
                        questionId
                    )
                );

                return {
                    success: true,
                    data: response.data,
                    message:
                        response.message,
                };

            }

            dispatch(
                deleteQuestionFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to delete question";

            dispatch(
                deleteQuestionFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };

        }
    };